import { getStyles } from './VerticalDivider.styles';
import { VerticalDividerBase } from './VerticalDivider.base';
import { styled } from '../../Utilities';
export var VerticalDivider = styled(VerticalDividerBase, getStyles, undefined, {
  scope: 'VerticalDivider'
});